// Translation: Russian > Generic
const generic = Object.freeze({
	accountSettings: '',
	active: '',
	all: '',
	apiCall: '',
	apiCall_one: '',
	apiCall_other: '',
	apiCalls: '',
	apiCallWithCount_one: '',
	apiCallWithCount_other: '',
	bestWithCount: '',
	billing: '',
	billingItemTypeItems: {
		ASSET_HOSTING: '',
		ASSET_HOSTING_REFUND: '',
		ASSET_REFUND: '',
		ASSET_TRAINING_REFUND: '',
		ASSET_USAGE: '',
		ASSET_USAGE_REFUND: '',
		AUTO_TOP_UP: '',
		BENCHMARK_OVERHEAD: '',
		EXPIRABLE_CREDIT: '',
		OTHER: '',
		OVERHEAD: '',
		OVERHEAD_FINETUNE_TRAINING: '',
		PAY_OUT: '',
		RESERVE_ASSET_USAGE: '',
		SERVICE_ASSET_USAGE: '',
		SUBSCRIPTION: '',
		SUPPLIER_FINETUNE_TRAINING: '',
		TOP_UP: '',
		TRANSFER: '',
		TRIAL_TOP_UP: '',
		UNKNOWN: '',
		UNSUBSCRIBE: ''
	},
	billingTypeItems: {
		service: '',
		transfer: ''
	},
	by: '',
	byWithItem: '',
	chartTypeItems: {
		barChart: '',
		boxPlotChart: ''
	},
	collected: '',
	comingSoon: '',
	comparisonTypeItems: {
		contains: '',
		different: '',
		differentWithValue: '',
		equal: '',
		equalWithValue: '',
		greaterThan: '',
		greaterThanOrEqual: '',
		greaterThanOrEqualWithValue: '',
		greaterThanWithValue: '',
		in: '',
		lessThan: '',
		lessThanOrEqual: '',
		lessThanOrEqualWithValue: '',
		lessThanWithValue: ''
	},
	configuration: '',
	creationDate: '',
	default: '',
	description: '',
	duration: '',
	error: '',
	extensions: '',
	false: '',
	free: '',
	generalSettings: '',
	id: '',
	integrations: '',
	lastUpdate: '',
	license: '',
	link: '',
	loading: '',
	membershipPlan: '',
	membershipPlans: '',
	modificationDate: '',
	name: '',
	new: '',
	none: '',
	noResults: '',
	notSelected: '',
	off: '',
	on: '',
	optional: '',
	owner: '',
	plainText: '',
	preferences: '',
	preview: '',
	price: '',
	profile: '',
	request: '',
	required: '',
	result: '',
	roleItems: {
		admin: '',
		member: '',
		owner: ''
	},
	saved: '',
	settings: '',
	sortingMethodItems: {
		dateNew: '',
		dateOld: '',
		updateLast: '',
		popularity: '',
		priceHigh: '',
		priceLow: ''
	},
	status: '',
	step: '',
	tag: '',
	tag_one: '',
	tag_other: '',
	tags: '',
	tagWithCount_one: '',
	tagWithCount_other: '',
	team: '',
	teamMembers: '',
	teamSettings: '',
	totalDuration: '',
	true: '',
	type: '',
	unavailable: '',
	unknown: '',
	unnamed: '',
	updatedAt: '',
	volume: '',
	worstWithCount: ''
})

// Export
export default generic
